import React from 'react'
import * as Yup from 'yup'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CheckCircle } from '@phosphor-icons/react'
import { Formik } from 'formik'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import { formValidation } from '../FormLegacy/validation'
import api from '../../api/api'

import AuthLayout from './AuthLayout'

const ResendActivationLink = () => {
  const { t } = useTranslation(['auth'])
  const { email } = useParams()
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const [error, setError] = React.useState('')

  const validationSchema = Yup.object().shape({
    email: formValidation.email,
  })

  const onSubmit = (values) => {
    setError('')
    setIsSubmitted(false)

    api
      .resendActivationLink(values.email)
      .then(() => {
        setIsSubmitted(true)
      })
      .catch((code) => {
        if (code === 404) {
          setError(t('auth:login.userNotFound'))
          return
        }
        if (code === 403) {
          setError(t('auth:resendActivationLink.mailBlocked'))
          return
        }
        setError(t('auth:shared.somethingWentWrongLater'))
      })
  }

  return (
    <AuthLayout>
      <Formik
        initialValues={{
          email,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleSubmit, values, handleChange, touched, errors }) =>
          isSubmitted ? (
            <div className="auth__password-reset-success">
              <CheckCircle size={32} />
              <h2>{t('auth:resendActivationLink.sentTitle')}</h2>
              <p>{t('auth:resendActivationLink.sentDescription')}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth__form">
              <h1>{t('auth:resendActivationLink.title')}</h1>
              <p className="auth__step-description">{t('auth:resendActivationLink.description')}</p>
              <TextField
                type="email"
                name="email"
                label={t('auth:shared.email')}
                placeholder={t('auth:shared.emailPlaceholder')}
                value={values.email}
                onChange={handleChange}
                isError={touched.email && !!errors.email}
              />
              {error && <p className="auth__form__description error">{error}</p>}
              <button type="submit" className="button button-primary">
                {t('auth:resendActivationLink.generate')}
              </button>
            </form>
          )
        }
      </Formik>
    </AuthLayout>
  )
}

export default ResendActivationLink
